import { render, staticRenderFns } from "./TrusteeStructure.vue?vue&type=template&id=d7d39642&scoped=true"
import script from "./TrusteeStructure.vue?vue&type=script&lang=js"
export * from "./TrusteeStructure.vue?vue&type=script&lang=js"
import style0 from "./TrusteeStructure.vue?vue&type=style&index=0&id=d7d39642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d39642",
  null
  
)

export default component.exports